const fetchSavedOffers = ({ http }) => http({
  url: '/saved-offers/me',
  params: {
    offset: 0,
    limit: 15
  }
})
  .then(({ data }) => data)
  .then(({ savedOffers }) => savedOffers.map(offer => ({
    ...offer,
    isFavourite: true,
    isSuperOffer: Boolean(offer.superOption),
    companyName: offer.employer,
    companyLogoUri: offer.logoFileUrl,
    isOneClickApply: Boolean(offer.oneClickApply),
    sug: ''
  })));

export default fetchSavedOffers;
